export default "__VITE_ASSET__CZIsdxOd__"